<div [ngClass]="{ caseDetailsInDialog: caseDetailsInDialog }">
  <div>
    <div
      class="spinner-wrapper d-flex justify-content-center align-items-center"
      style="min-height: 15.625rem"
      *ngIf="!caseDetails">
      <mat-spinner
        class="loading-spinner"
        strokeWidth="5"
        diameter="50"></mat-spinner>
    </div>
    <div class="row d-flex flex-wrap" *ngIf="caseDetails">
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.customer">
        <div class="description-row-header">Site Name</div>
        <pre class="description-row-content">{{ caseDetails.customer }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.clientName">
        <div class="description-row-header">Account Name</div>
        <pre class="description-row-content">{{ caseDetails.clientName }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.userName">
        <div class="description-row-header">Contact Name</div>
        <pre class="description-row-content">{{ caseDetails.userName }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.emailaddress">
        <div class="description-row-header">Email Address</div>
        <pre class="description-row-content">{{
          caseDetails.emailaddress
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.phoneNumber">
        <div class="description-row-header">Phone Number</div>
        <pre class="description-row-content">{{ caseDetails.phoneNumber }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.wastestream">
        <div class="description-row-header">Waste Stream</div>
        <pre class="description-row-content">{{ caseDetails.wastestream }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.caseType">
        <div class="description-row-header">Case Type</div>
        <pre class="description-row-content">{{ caseDetails.caseType }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="
          caseDetails.subCaseType &&
          !caseDetails.subCaseType?.toLowerCase()?.startsWith('hauler')
        ">
        <div class="description-row-header">Sub-Case Type</div>
        <pre class="description-row-content">{{ caseDetails.subCaseType }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.scheduleA">
        <div class="description-row-header">Site Identifier</div>
        <pre class="description-row-content">{{ caseDetails.scheduleA }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.jllAddressStreet">
        <div class="description-row-header">Site Address</div>
        <pre class="description-row-content">{{
          caseDetails.jllAddressStreet
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.jllAddressCity">
        <div class="description-row-header">Site City</div>
        <pre class="description-row-content">{{
          caseDetails.jllAddressCity
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.jllAddressState">
        <div class="description-row-header">Site State</div>
        <pre class="description-row-content">{{
          caseDetails.jllAddressState
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.jllAddressZipCode">
        <div class="description-row-header">Site Zip Code</div>
        <pre class="description-row-content">{{
          caseDetails.jllAddressZipCode
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.eqType">
        <div class="description-row-header">Equipment Type</div>
        <pre class="description-row-content">{{ caseDetails.eqType }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.eqSize">
        <div class="description-row-header">Equipment Size</div>
        <pre class="description-row-content">{{ caseDetails.eqSize }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="
          caseDetails.serviceRequestedDate &&
          caseDetails.serviceRequestedDate > minDate
        ">
        <div class="description-row-header">Requested Date</div>
        <pre class="description-row-content">{{
          caseDetails.requestedDate | date: 'MM/dd/yyyy'
        }}</pre>
      </div>
      <div
        [ngClass]="['col-12', caseDetailsInDialog ? '' : 'col-md-3']"
        *ngIf="caseDetails.caseCreatedOn">
        <div class="description-row-header">Created</div>
        <pre class="description-row-content">{{
          caseDetails.caseCreatedOn | date: 'MM/dd/yyyy'
        }}</pre>
      </div>
    </div>
    <div
      class="row"
      *ngIf="
        caseDetails?.description ||
        caseDetails?.caseOriginCode === caseOriginCode.EMAIL
      ">
      <div class="col-12">
        <div class="description-row-header">Description</div>
        <pre class="description-row-content"
          >{{
            caseDetails.caseOriginCode === caseOriginCode.EMAIL
              ? 'This case originated from an email and not all details can be provided. Please note that all follow-up communication will be conducted via email.'
              : caseDetails.description
          }}
        </pre>
      </div>
    </div>
    <div class="row" *ngIf="caseDetails?.attachFileDetails.length">
      <div class="col-12 description-row-header">Case Attachment</div>
      <ng-container *ngFor="let filesDetail of caseDetails?.attachFileDetails">
        <div class="col-12 col-md-3">
          <div class="description-row-header">File Name</div>
          <a
            class="description-row-content"
            (click)="
              downloadFile(filesDetail.documentBody, filesDetail.fileName)
            ">
            {{ filesDetail.fileName }}
            <img src="../assets/images/download.svg" alt="download" />
          </a>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="caseDetails?.posts.length" class="row posts-container mt-2">
    <div class="col">
      <h1 class="history">History</h1>
      <ng-container *ngFor="let post of caseDetails?.posts">
        <div class="post-container" [id]="post.id">
          <div class="post-item">
            <div class="post-item--header d-flex">
              <div class="d-flex align-items-center">
                <mat-icon>calendar_month</mat-icon>
                <label>{{
                  datePipe.transform(
                    post.postCreatedOn + 'Z',
                    'MM/dd/yyyy, h:mm:ss a'
                  )
                }}</label>
              </div>
              <div class="d-flex align-items-center ml-2">
                <mat-icon>person</mat-icon>
                <label>{{ post.postCreatedBy }}</label>
              </div>
            </div>
            <pre class="post-item--content">{{ post.text }}</pre>
          </div>
          <ng-container *ngFor="let reply of post.postReplys">
            <div class="post-item reply-item">
              <div class="post-item--header">
                <div>
                  <mat-icon>calendar_month</mat-icon>
                  <label>{{
                    datePipe.transform(
                      reply.replyCreatedOn + 'Z',
                      'MM/dd/yyyy, h:mm:ss a'
                    )
                  }}</label>
                </div>
                <div>
                  <mat-icon>person</mat-icon>
                  <label>{{ reply.replyPostedBy }}</label>
                </div>
              </div>
              <pre class="post-item--content">{{ reply.text }}</pre>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="row" *ngIf="caseDetails?.caseResolutionDetails">
    <div class="col-12" style="margin-bottom: 0.5rem">
      <div class="description-row-header">Resolution Description</div>
      <pre
        style="margin-bottom: 0.5rem"
        class="description-row-content"
        *ngFor="let item of caseDetails.caseResolutionDetails"
        >{{ item.subject }}</pre
      >
    </div>
  </div>

  <div class="row notes-editor-container" *ngIf="showFollowUp">
    <div class="col">
      <mat-form-field
        appearance="outline"
        [hintLabel]="'Max ' + notesMaxlength + ' characters'"
        style="width: 100%; margin-top: 10px">
        <mat-label>Add Notes</mat-label>
        <textarea
          matInput
          #input
          [maxlength]="notesMaxlength"
          placeholder="Leave a follow-up notes"
          required
          [formControl]="notes"></textarea>
        <mat-hint align="end"
          >{{ input.value?.length || 0 }}/{{ notesMaxlength }}</mat-hint
        >
      </mat-form-field>
    </div>
  </div>
  <div class="row expanded-action-container">
    <div
      class="col text-center"
      *ngIf="
        caseDetails &&
        caseDetails.statusCode !== 5 &&
        caseDetails.statusCode !== 1000 &&
        caseDetails.statusCode !== 2000 &&
        caseDetails.statusCode !== 6
      ">
      <button
        *ngIf="!showFollowUp"
        mat-stroked-button
        (click)="setShowFollowUp(true)"
        style="padding: 0 0.5rem">
        Follow-up
      </button>
      <button
        *ngIf="showFollowUp"
        mat-stroked-button
        (click)="addNotes(element)"
        [disabled]="notes.value.length === 0"
        style="padding: 0 0.5rem">
        Submit
      </button>
      <button
        (click)="
          setExpandedElement(null); setShowFollowUp(false); this.notes.reset('')
        "
        mat-stroked-button
        style="margin-left: 1.875rem; padding: 0 0.5rem"
        *ngIf="showFollowUp">
        Reset Follow-up
      </button>
      <button
        mat-stroked-button
        color="warn"
        (click)="openCancelCaseDialog(caseDetails)"
        style="padding: 0 0.5rem"
        class="ml-2">
        Cancel Case
      </button>
    </div>
  </div>
</div>
